'use client';

import { useLocale } from '@instamenu/context-i18n';
import { UserMenu as SystemUserMenu, UserMenuLink } from '@instamenu/ui-system-next';
import { useRouter } from 'next/navigation';

export const UserMenu = () => {
  const router = useRouter();
  const { i18n } = useLocale();

  return (
    <SystemUserMenu>
      <UserMenuLink onClick={() => router.push('/preferences')}>
        {i18n.t('mainMenu.preferences')}
      </UserMenuLink>
    </SystemUserMenu>
  );
};
